import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FileUploadSourceType } from 'src/app/shared/enum-value';
import { InsrAcqnDashboardDetails } from 'src/app/model/InsuranceAcquisitionDetails';
import { FileUploadService } from 'src/app/services/file-upload.service';
import { Utils } from 'src/app/shared/utils';
import { LaunchDarklyUtil } from 'src/app/shared/launch-darkly-util';
import { Router } from '@angular/router';
import { ApiService } from 'src/app/services/api.service';

@Component({
  standalone: false,
  selector: 'app-action-required-insurance',
  templateUrl: './action-required-insurance.component.html',
  styleUrl: './action-required-insurance.component.css'
})
export class ActionRequiredInsuranceComponent implements OnInit {
  @Input() set lenderActionRequired(_lenderActionRequired: InsrAcqnDashboardDetails[]) {
    if (_lenderActionRequired) {
      this.data = [];
      for (const item of _lenderActionRequired) {
        this.data.push({
          propertyName: item.propNme,
          pastDue: this.isPastDue(item.reqdSubmtDt),
          requiredSubmittedDate: this.utils.getFormattedDate(item.reqdSubmtDt),
          lastSubmittedDate: this.utils.getFormattedDate(item.propInsrSubmtDt),
          dusGatewayDealAndID: item.dlNme + ' (' + item.dusDealId + ')',

                    // TODO :Add other 10 items here
          propAccord28Typ: item.propAccord28Typ,
          propAmrcnLandTtlAsscTyp : item.propAmrcnLandTtlAsscTyp,
          propFldAnlysWkshTyp: item.propFldAnlysWkshTyp,
          propNfipTyp: item.propNfipTyp,
          propPrvtOrExcsFldInsrCvrgTyp: item.propPrvtOrExcsFldInsrCvrgTyp,
          propSpclFldHzrdDtmnFormTyp: item.propSpclFldHzrdDtmnFormTyp,
          propSchOfValTyp: item.propSchOfValTyp,
          propAccord25Typ: item.propAccord25Typ,
          propInsrTyp: item.propInsrTyp,
          propLiabPlcyTyp: item.propLiabPlcyTyp,
          
          estimatedAcquisitionDate: this.utils.getFormattedDate(item.aqsnDt),
          collateralReferenceNumber: item.coltRefNo,
          insr: item.insr,

          acquisitionDealId: item.aqsnDealId,
          propertyMasterNumber: item.propMstrNo,
          transType: item.transType,
          ssn: item.ssn,
          propId: item.propMstrNo,
          cmmtNo: item.cmmtNo
        });
      }

    }
  }

  @Output() propertyFileUploadDetails: EventEmitter<object> = new EventEmitter<object>();

  data: any = [];
  showUploadFiles = false;

  constructor(private router: Router,
    private apiService: ApiService,
    private utils: Utils, private fileUploadService: FileUploadService, private launchDarkly: LaunchDarklyUtil) { }

  ngOnInit(): void {

  }

  isPastDue(reqDate) {
    if (!reqDate)
      return false;

    var today = new Date();

    if (reqDate < today) {
      return true;
    } else if (reqDate > today) {
      return false;
    } else {
      return false;
    }
  }

  getUploadFilesDialogStatus(flag: boolean) {
    this.showUploadFiles = flag;
  }

  showUploadFilesDialog(flag: boolean, propertyName: string, dusGatewayDealAndID: string, collateralReferenceNumber: string, acquisitionDealId: string, propertyMasterNumber: string, transType: string, ssn: string, propId: string, cmmtNo: string) {
    //Launch Darkly
    this.launchDarkly.getLaunchDarklyShutDown(this, this.launchDarklyCallback)

    let selectedPropertyName = propertyName;
    let selectedDusDealId = dusGatewayDealAndID.match(/\(([^)]+)\)$/)[1];
    let selectedColtRefNo = collateralReferenceNumber;
    let selectedAqsnDealId = acquisitionDealId;
    let selectedPropertyMasterNumber = propertyMasterNumber;
    let selectedTransType = transType;
    let selectedSSN = ssn;
    let selectedPropId = propId;
    let selectedCmmtNo = cmmtNo;
    this.propertyFileUploadDetails.emit({ selectedPropertyName, selectedDusDealId, selectedColtRefNo, selectedAqsnDealId, selectedPropertyMasterNumber, selectedTransType, selectedSSN, selectedPropId, selectedCmmtNo });
    this.showUploadFiles = flag;

    this.fileUploadService.setSource(FileUploadSourceType.ActionRequired);
  }

  launchDarklyCallback(systemDownFlagValue: boolean, caller) {
    caller.systemDownFlagValue = systemDownFlagValue;
    console.log('LaunchDarkly flag systemDownFlagValue = ', caller.systemDownFlagValue);
    if (Object.keys(caller.systemDownFlagValue).length > 0) {
      // caller.apiService.systemDownFlagValue = caller.systemDownFlagValue;
      caller.menu = [];
      caller.showSystemDown = true;
      caller.showDueDiligenceDashboard = false;
      caller.unauthorizedUser = false;

      caller.apiService.shutDownApp = true;
      caller.router.navigate([''], { skipLocationChange: true });
    }
  }
}


